export default class DartsParser {
    static parse(str) {
        var base = 0;
            var multiplier = 0;
            if (!isNaN(str)) {
                base = parseInt(str);
                multiplier = 1;
            }
            else if (str.indexOf("DBE") == 0) {
                base = 25;
                multiplier = 2;
            }
            else if (str.indexOf("D") == 0) {
                base = parseInt(str.replace("D", ""));
                multiplier = 2;
            }
            else if (str.indexOf("T") == 0) {
                base = parseInt(str.replace("T", ""));
                multiplier = 3;
            }
            else if (str.indexOf("BE") == 0) {
                base = 25;
                multiplier = 1;
            }
            return {base: base, multiplier: multiplier, str: str, value: base*multiplier};
    }
}
